import { initContract } from "@ts-rest/core";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    organizationNatsPathParamsSchema,
    organizationNatsQuerySchema,
    workspaceNatsPathParamsSchema,
} from "@common/schemas/nats.schema";

const c = initContract();

export interface NatsJwtResponse {
    jwt: string;
}

export const natsContract = c.router({
    getNatsJwt: {
        method: "GET",
        path: "/workspace/:workspaceId/nats/jwt",
        pathParams: workspaceNatsPathParamsSchema,
        responses: {
            200: c.type<NatsJwtResponse>(),
            400: ErrorMessageSchema,
            401: ErrorMessageSchema,
            404: ErrorMessageSchema,
        },
    },
    getOrganizationNatsJwt: {
        method: "GET",
        path: "/organization/:organizationId/nats/jwt",
        pathParams: organizationNatsPathParamsSchema,
        query: organizationNatsQuerySchema,
        responses: {
            200: c.type<NatsJwtResponse>(),
            400: ErrorMessageSchema,
            401: ErrorMessageSchema,
            404: ErrorMessageSchema,
        },
    },
});
